import React from "react";
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/PageHeader';
import VillageGallery from '../components/VillageGallery';
import "./OurVillage.css";
import { Link } from "react-router-dom";
import VillageIllustration from "../components/VillageIllustration";

export default function OurVillage() {
  const { t } = useTranslation();

  return (
    <div className="our-village-page">
      <div className="village-container section-padding bg-image-section">
        <PageHeader
          breadcrumb={[
            <Link key="home" to="/">{t('home.breadcrumb')}</Link>,
            <span key="our-village">{t('ourVillage.breadcrumb')}</span>
          ]}
          title={t('ourVillage.title')}
          description={t('ourVillage.description')}
        />
        <VillageGallery />
      </div>
      <VillageIllustration />
    </div>
  );
}